export function adjustMaxWidth() {
    // Get all elements with the class '.site-farlo-ui-crm'
    const elements = document.querySelectorAll('.site-farlo-ui-crm');

    // Function to set max-width
    const setMaxWidth = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 980) {
            // Calculate the new max-width
            const newMaxWidth = `${windowWidth - 10}px`;

            // Apply the new max-width to all selected elements
            elements.forEach(element => {
                element.style.maxWidth = newMaxWidth;
            });
        } else {
            // Reset the max-width for widths 980px or greater
            elements.forEach(element => {
                element.style.maxWidth = '';
            });
        }
    };

    // Call the function initially and on every window resize
    setMaxWidth();
    window.addEventListener('resize', setMaxWidth);
}